import { useContext, useEffect, useState } from "react";
import { getCustomisationValue } from "../../../EditablePreview/EditablePreview";
import { changeNumericalFieldValue, changeStringFieldValue } from "../../ModuleList";
import ModuleNumericalInput from "../../components/ModuleNumericalInput";
import ModuleTextInput from "../../components/ModuleTextInput";
import { ShowColorPicker } from "../../../../../../forms/ColorPicker/ColorPickerPopUp";
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";
import { COLOUR_NAME_TO_COLOUR_HEX } from "../../../../../../../helpers/Colours";
import { renderFirstCustomBlock, renderSecondCustomBlock } from "../../customFields/CustomFieldRenderer";

const ShadowModule = (props) => {
    const { moduleConfig, customisationVars } = props;
    console.log("Rendering ShadowModule with props:", props);

    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    const visualisationComponentKey = props.visualisationComponentKey || null;
    const index = props.index ?? 0;

    let colorFieldConfig = null;
    let opacityFieldConfig = null;
    let positionFieldConfig = null;
    let blurFieldConfig = null;
    let spreadFieldConfig = null;
    for (let i = 0; i < moduleConfig.fields.length; i++) {
        const field = moduleConfig.fields[i];
        if (field.field.includes('shadow-color')) {
            colorFieldConfig = field;
        } else if (field.field.includes('shadow-opacity')) {
            opacityFieldConfig = field;
        } else if (field.field.includes('shadow-position')) {
            positionFieldConfig = field;
        } else if (field.field.includes('shadow-blur')) {
            blurFieldConfig = field;
        } else if (field.field.includes('shadow-spread')) {
            spreadFieldConfig = field;
        }
    }

    const [color, setColor] = useState(getCustomisationValue(customisationVars, colorFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '#000000');
    const [opacity, setOpacity] = useState(getCustomisationValue(customisationVars, opacityFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '100');

    useEffect(() => {
        if (colorFieldConfig?.dataLink) {
            const colorValue = getCustomisationValue(customisationVars, colorFieldConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setColor(colorValue ?? '#000000');
        } else {
            setColor('#000000');
        }
        if (opacityFieldConfig?.dataLink) {
            const opacityValue = getCustomisationValue(customisationVars, opacityFieldConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setOpacity(opacityValue ?? '100');
        } else {
            setOpacity('100');
        }
    }, [moduleConfig, customisationVars, colorFieldConfig, opacityFieldConfig, props.forceUpdate]);

    const changeColorFieldValue = (value) => {
        if (colorFieldConfig) {
            if (changeStringFieldValue(customisationVars, colorFieldConfig, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setColor(value);
                props?.forceUpdateComponent?.();
            }
        }
    }

    const changeOpacityFieldValue = (value) => {
        if (opacityFieldConfig) {
            if (changeNumericalFieldValue(customisationVars, opacityFieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setOpacity(value);
                props?.forceUpdateComponent?.();
            }
        }
    }

    const [offsetX, setOffsetX] = useState(getCustomisationValue(customisationVars, positionFieldConfig?.["position-x"]?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '-');
    const [offsetY, setOffsetY] = useState(getCustomisationValue(customisationVars, positionFieldConfig?.["position-y"]?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '-');
    useEffect(() => {
        if (positionFieldConfig?.["position-x"]?.dataLink) {
            const offsetXValue = getCustomisationValue(customisationVars, positionFieldConfig["position-x"].dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setOffsetX(offsetXValue ?? '-');
        } else {
            setOffsetX('-');
        }
        if (positionFieldConfig?.["position-y"]?.dataLink) {
            const offsetYValue = getCustomisationValue(customisationVars, positionFieldConfig["position-y"].dataLink, index, visualisationComponentKey, props.selectedFeatureNode);
            setOffsetY(offsetYValue ?? '-');
        } else {
            setOffsetY('-');
        }
    }, [customisationVars, positionFieldConfig, props.forceUpdate]);

    const changeOffsetFieldValue = (field, value) => {
        if (positionFieldConfig?.[field]) {
            if (changeNumericalFieldValue(customisationVars, positionFieldConfig[field], value, true, index, visualisationComponentKey, props.selectedFeatureNode)) {
                props?.forceUpdateComponent?.();
            }
        }
    }

    const [blur, setBlur] = useState(getCustomisationValue(customisationVars, blurFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '0');
    const [spread, setSpread] = useState(getCustomisationValue(customisationVars, spreadFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '0');
    useEffect(() => {
        if (blurFieldConfig?.dataLink) {
            const blurValue = getCustomisationValue(customisationVars, blurFieldConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setBlur(blurValue ?? '0');
        } else {
            setBlur('0');
        }
        if (spreadFieldConfig?.dataLink) {
            const spreadValue = getCustomisationValue(customisationVars, spreadFieldConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setSpread(spreadValue ?? '0');
        } else {
            setSpread('0');
        }
    }, [moduleConfig, customisationVars, blurFieldConfig, spreadFieldConfig, props.forceUpdate]);

    const changeBlurFieldValue = (value) => {
        if (blurFieldConfig) {
            if (changeNumericalFieldValue(customisationVars, blurFieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setBlur(value);
                props?.forceUpdateComponent?.();
            }
        }
    }
    const changeSpreadFieldValue = (value) => {
        if (spreadFieldConfig) {
            if (changeNumericalFieldValue(customisationVars, spreadFieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setSpread(value);
                props?.forceUpdateComponent?.();
            }
        }
    }

    return (
        <div className="v2-basic-module-holder">
            <h5>Shadow</h5>

            {renderFirstCustomBlock(props)}

            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Color</div>
                    <ModuleTextInput
                        fieldLabel={<div className="v2-module-block-field-input-label" style={{backgroundColor: COLOUR_NAME_TO_COLOUR_HEX(color, campaignContext.campaignData)}} />}
                        value={color}
                        fieldId={'shadow-color'}
                        enabled={true}
                        editable={false}
                        onChange={null}
                        onClick={() => {ShowColorPicker(color, changeColorFieldValue, campaignContext.campaignData, 'Shadow Color', () => {}, () => {})}}
                        maxLength={7}
                    />
                </div>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Opacity</div>
                    <ModuleNumericalInput
                        fieldLabel={<div className="v2-module-block-field-input-label" style={{opacity: opacity / 100}} />}
                        value={opacity}
                        fieldId={'shadow-opacity'}
                        enabled={!!opacityFieldConfig?.dataLink}
                        onChange={(fieldId, value) => changeOpacityFieldValue(value)}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    />
                </div>
            </div>

            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Offset</div>
                    <ModuleNumericalInput
                        fieldLabel="X"
                        value={offsetX}
                        fieldId="position-x"
                        enabled={!!positionFieldConfig?.["position-x"]?.dataLink}
                        onChange={(fieldId, value) => changeOffsetFieldValue(fieldId, value)}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[-20, -15, -12, -10, -8, -6, -4, -2, 0, 2, 4, 6, 8, 10, 12, 15, 20]}
                    />
                </div>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>&nbsp;</div>
                    <ModuleNumericalInput
                        fieldLabel="Y"
                        value={offsetY}
                        fieldId="position-y"
                        enabled={!!positionFieldConfig?.["position-x"]?.dataLink}
                        onChange={(fieldId, value) => changeOffsetFieldValue(fieldId, value)}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[-20, -15, -12, -10, -8, -6, -4, -2, 0, 2, 4, 6, 8, 10, 12, 15, 20]}
                    />
                </div>
            </div>
            
            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Blur</div>
                    <ModuleNumericalInput
                        fieldLabel={<div className="v2-module-block-field-input-label" style={{height: 1, filter: `blur(${blur / 2}px)`}} />}
                        value={blur}
                        fieldId={'shadow-blur'}
                        enabled={!!blurFieldConfig?.dataLink}
                        onChange={(fieldId, value) => changeBlurFieldValue(value)}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                    />
                </div>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Spread</div>
                    <ModuleNumericalInput
                        fieldLabel={<div className="v2-module-block-field-input-label" style={{height: Math.round(spread / 2) + 'px'}} />}
                        value={spread}
                        fieldId={'shadow-spread'}
                        enabled={!!spreadFieldConfig?.dataLink}
                        onChange={(fieldId, value) => changeSpreadFieldValue(value)}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 15, 20]}
                    />
                </div>
            </div>

            {renderSecondCustomBlock(props)}

        </div>
    );
}

export default ShadowModule;
